const KEY = "doctogo_admin_token";
const USER_KEY = "doctogo_admin_user";

export const getToken = () => localStorage.getItem(KEY);
export const setSession = (token, user) => {
  localStorage.setItem(KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};
export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY));
  } catch {
    return null;
  }
};
export const clearSession = () => {
  localStorage.removeItem(KEY);
  localStorage.removeItem(USER_KEY);
};
export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const formatApiError = (detail) => {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
